/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';

import { useMutation } from '@apollo/client';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { UPSERT_DEVOULUTION_PAGE_CONFIGS } from './graphql';

export function useUpsertDevolutionPageConfigs() {
  const { setLoading, setErrorMessage, setSuccessMessage } =
    useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const [UpsertDevolutionPageConfigs, { loading: apiLoading }] = useMutation(
    UPSERT_DEVOULUTION_PAGE_CONFIGS,
  );

  useEffect(() => {
    if (apiLoading) {
      setIsLoading(true);
      setLoading(true);
    } else {
      setIsLoading(false);
      setLoading(false);
    }
  }, [apiLoading]);

  async function upsertDevolutionPageConfigs({ storeId, configs }) {
    const payload = JSON.parse(JSON.stringify(configs));
    // This is necessary because the API doesn't accept __typename, and
    // it is kept by the state (saves the api response).
    delete payload.__typename;
    try {
      const res = await UpsertDevolutionPageConfigs({
        variables: { configs: { storeId, ...payload } },
      });
      if (res.data.upsertDevolutionPageConfigs.code === 200) {
        setSuccessMessage(
          res.data.upsertDevolutionPageConfigs.message ||
            'Configurações salvas com sucesso.',
        );
      } else {
        setErrorMessage(res.data.upsertDevolutionPageConfigs.message);
      }
    } catch (e) {
      setErrorMessage('Algo deu errado, tente novamente mais tarde.');
    }
  }

  return {
    upsertDevolutionPageConfigs,
    loading: isLoading,
  };
}
